import { render, staticRenderFns } from "./ricercaCandidati.vue?vue&type=template&id=60a6c570&scoped=true&"
import script from "./ricercaCandidati.vue?vue&type=script&lang=js&"
export * from "./ricercaCandidati.vue?vue&type=script&lang=js&"
import style0 from "./ricercaCandidati.vue?vue&type=style&index=0&id=60a6c570&scoped=true&lang=css&"
import style1 from "./ricercaCandidati.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a6c570",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBottomSheet,VBtn,VCol,VDatePicker,VImg,VListItem,VListItemTitle,VMenu,VRow,VSheet,VTextField})
